$(() => {
    $(window).on('scroll load', () => {
        let scrollTop = $(window).scrollTop();
        let windowHeight = $(window).height();
        let $body = $('body');

        if (scrollTop > (windowHeight / 3)) {
            $body.addClass('scrolled');
        } else {
            $body.removeClass('scrolled');
        }
    })
});